// The URL handleOrgSwitchSuccess (queries.ts) reloads to after a successful org
// switch. Must keep the query string: the CLI login flow (cli-authorize.tsx) lands
// here with `?state=<pkce-state>` in the URL, and dropping it on reload breaks
// `plivo login` for every org-picker user.
//
// A LEAF module on purpose, per AGENTS.md failure mode 1 (mock.module leaks
// process-globally) — nothing here imports anything, so no mock.module of a shared
// module can ever shadow it. `loc` takes a plain object in tests instead of stubbing
// `window.location`: stubbing it broke 3 unrelated tests in
// verify/logs/__tests__/filters.test.tsx (`This BroadcastChannel is closed`), because
// `Object.getOwnPropertyDescriptor(window.location, 'pathname')` returns undefined for
// an inherited accessor, so an `afterAll` restore silently no-ops and the stub leaks
// into every later test file in bun's single-process runner.
export const orgSwitchReloadTarget = (
  loc: Pick<Location, 'pathname' | 'search'> = window.location,
) => loc.pathname + loc.search
